import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import 'react-quill/dist/quill.snow.css';
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import 'react-datepicker/dist/react-datepicker.css';
import { Provider } from "react-redux";

import store from "./store";
import ErrorBoundary from "components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </Provider>
);

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div>
      <h2>Something went wrong: {error.message}</h2>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

function handleError(error, info) {
  console.log('Error: ', error, 'Info: ', info);
}

// themes will be available in structure.txt

// Resources
 
// Projects
 
// Timesheet
 
// Invoices
 
// Dashboard and Reports

// login only email